module.exports = __webpack_public_path__ + "img/wmap.f5e0a555.png";